<template>
    <div class="ellipsis">
        <span>{{ textComputed }}</span>
        <template v-if="text.length > maxLength">
            <span v-if="ellipsises.more">...</span>
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span class="more" @click="ellipsises.more = !ellipsises.more">
                {{ ellipsises.more ? '查看更多' : '收起' }}
            </span>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        text: {
            type: String,
            default: ''
        },
        maxLength: {
            type: Number,
            default: 68
        }
    },
    data() {
        return {
            ellipsises: {
                more: true
            }
        };
    },
    computed: {
        textComputed() {
            return this.ellipsises.more && this.text.length > this.maxLength
                ? this.text.slice(0, this.maxLength - 5)
                : this.text
        }
    },
    mounted() { },
    methods: {},
    watch: {
        text() {
            if (!this.ellipsises.more) this.ellipsises.more = true
        }
    },
};
</script>
<style lang="scss" scoped>
.more {
    display: inline-block;
    color: #5961f9;
    text-decoration: underline;
}
</style>
  